import {Graphics, Sprite, Texture, TilingSprite} from 'pixi.js';
import {TextureUrlLoader} from '../../../utils/TextureUrlLoader';
import {ActiveData} from '../../../data/ActiveData';
import {Grid} from './table_background/Grid';
import {PatternRepeat} from '../../../data/active_data/field_config/BackgroundData';
import {Logo} from './table_background/Logo';
import {DynamicData} from '../../../data/DynamicData';
import {StaticData} from '../../../data/StaticData';

export class TableBackground extends Sprite
{
    private bgRect: Graphics = new Graphics();
    private tilingSprite: TilingSprite | undefined;
    private bgTexture: Texture | null = null;
    private logo: Logo | undefined;
    private grid: Grid | undefined;

    constructor() {
        super();
        this.addChild(this.bgRect);
    }

    /**
     * Загрузка и установка фонового рисунка
     * @param path - относительный путь к рисунку
     * @param gameField - данные об игровом поле
     */
    async load(path: string): Promise<void> {
        this.bgTexture = await TextureUrlLoader.load(path);
        if (!this.bgTexture) {
            return;
        }
        this.tilingSprite = new TilingSprite(this.bgTexture, 1, 1);
        this.addChild(this.tilingSprite);
        switch (ActiveData.root.background.pattern) {
            case PatternRepeat.REPEAT_X:
                this.tilingSprite.width = ActiveData.root.width;
                this.tilingSprite.height = this.tilingSprite.texture.height;
                break;
            case PatternRepeat.REPEAT_Y:
                this.tilingSprite.width = this.tilingSprite.texture.width;
                this.tilingSprite.height = ActiveData.root.height;
                break;
            case PatternRepeat.REPEAT:
                this.tilingSprite.width = ActiveData.root.width;
                this.tilingSprite.height = ActiveData.root.height;
                break;
            default:
                this.tilingSprite.width = this.tilingSprite.texture.width;
                this.tilingSprite.height = this.tilingSprite.texture.height;
                this.tilingSprite.anchor.set(.5, .5);
                this.tilingSprite.position.set(ActiveData.root.width / 2, ActiveData.root.height / 2);
                break;
        }
    }

    /**
     * Установка цвета фона
     * @param color - цвет в формате 0x0 - 0xffffff
     * @param gameField - данные об игровом поле
     */
    fill(color: number): void {
        this.bgRect.clear();
        this.bgRect.lineStyle(1, 0xFFFFFF);
        this.bgRect.beginFill(color || 0x35654d);
        this.bgRect.drawRect(0, 0, ActiveData.root.width, ActiveData.root.height);
        this.bgRect.endFill();
    }

    /**
     * Загрузка и установка бэкграунд-картинки и цвета фона
     */
    async initialize(): Promise<void> {
        let path: string = ActiveData.root.background.image;
        let strColor = ActiveData.root.background.color;
        let numColor = parseInt(strColor.slice(1), 16);

        if (this.tilingSprite) {
            this.removeChild(this.tilingSprite);
            TextureUrlLoader.forget(this.bgTexture!);
            this.tilingSprite.destroy({texture: true, baseTexture: true});
            this.tilingSprite = undefined;
            this.bgTexture = null;
        }

        path && await this.load(path);
        this.fill(numColor);

        if (this.logo) {
            this.removeChild(this.logo);
            this.logo.destroy();
            this.logo = undefined;
        }
        if (ActiveData.root.showLogo) {
            this.logo = new Logo();
            this.addChild(this.logo);
            this.logo.position.set(ActiveData.root.width / 2, ActiveData.root.height / 2);
        }

        if (!StaticData.isAdmin) {
            return;
        }

        if (this.grid) {
            this.removeChild(this.grid);
            this.grid.destroy();
        }
        this.grid = new Grid();
        this.grid.draw(ActiveData.root.width, ActiveData.root.height, DynamicData.gridEvenDraw);
        this.addChild(this.grid);
    }

    setGridVisible(value: boolean) {
        this.grid!.visible = value;
        value && this.grid!.draw(ActiveData.root.width, ActiveData.root.height, DynamicData.gridEvenDraw = !DynamicData.gridEvenDraw);
    }
}
